import { ImportUtilityModel } from '../../AddImportUtilityDrawer/typings'
import { useBranchAndSalesTeam } from './useBranchAndSalesTeam'
import { useSalesFunnel } from './useSalesFunnel'
import { useDate } from './useDate'
import { useOpportunity } from './useOpportunity'
import { useService } from './useService'
import { useValidate } from './useValidate'
import { useRowData } from './useRowData'
import { useAssignIds } from './useAssignIds'
import { useOwner } from './useOwner'

export function useRowHooks(importSettings: ImportUtilityModel | null) {
  const {
    allBranches,
    allSalesTeams,
    allSalesFunnels,
    allUsers,
    allServices,
    allServiceFrequencies,
    allSources,
    allCampaigns,
    allTargetPests,
    allLocationTypes,
    allDivisions,
    allStages,
  } = useRowData()

  const {
    assignBranchAndDefaultSalesTeam,
    assignSalesTeamAndDefaultBranch,
    assignSaleTeamsForBranch,
    assignUsersForSalesTeam,
  } = useBranchAndSalesTeam(allBranches, allSalesTeams, allUsers)

  const { assignSalesFunnelAndDefaultStage, assignFunnelStageIds } =
    useSalesFunnel(allSalesFunnels, allStages)

  const { assignOwnerAndDefault } = useOwner()

  const { assignAndFormatDates } = useDate()

  const { assignOpportunityName } = useOpportunity(allServices)

  const { assignOtherIds } = useAssignIds(
    allSources,
    allCampaigns,
    allTargetPests,
    allLocationTypes,
    allDivisions,
    allServiceFrequencies,
  )

  const {
    assignServiceId,
    assignServicesForBranch,
    assignDefaultsForServiceFields,
  } = useService(allServices, allServiceFrequencies, importSettings)

  const {
    validateUSCAPostalCode,
    validateImportPhoneNumbers,
    validateCreationDate,
    validateCustomFieldDates,
    validateServiceFields,
    validateReferralFields,
    validateOwner,
  } = useValidate(importSettings)

  return [
    assignBranchAndDefaultSalesTeam,
    assignSalesTeamAndDefaultBranch,
    assignSalesFunnelAndDefaultStage,
    assignOwnerAndDefault,
    assignOtherIds,
    assignServiceId,
    assignFunnelStageIds,
    assignAndFormatDates,
    assignSaleTeamsForBranch,
    assignUsersForSalesTeam,
    assignServicesForBranch,
    assignDefaultsForServiceFields,
    assignOpportunityName,
    validateUSCAPostalCode,
    validateImportPhoneNumbers,
    validateCreationDate,
    validateCustomFieldDates,
    validateServiceFields,
    validateReferralFields,
    validateOwner,
  ]
}
